module.exports = __webpack_public_path__ + "img/bg_main0605.a2e9cf97.png";